import Vue from "vue";

export default (ctx, inject) => {
  const { app } = ctx;
  const user = app.store.getters["Profile/getUser"];

  if (app.$config.churnZeroEnabled) {
    if (app.$config.churnZeroAppKey && app.$config.churnZeroEndpoint) {
      Vue.use(ChurnZero, {
        scriptUrl: app.$config.churnZeroEndpoint,
        appKey: app.$config.churnZeroAppKey,
        accountId: user?.companySfId,
        contactId: user?.salesforceId,
        site: "PC",
        inject,
        router: app.router,
      });
    } else {
      console.error("ChurnZero enabled without appkey or endpoint");
    }
  }
};

function loadChurnZeroScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = url;
    script.type = "text/javascript";
    script.onload = resolve;
    script.onerror = reject;

    (document.head || document.getElementsByTagName("head")[0]).appendChild(
      script
    );
  });
}

function ChurnZero(Vue, setupOptions = {}) {
  const { scriptUrl, appKey, accountId, contactId, site, inject, router } =
    setupOptions;
  const errorPrefix = "[vixio churn-zero plugin]";

  if (!appKey) {
    throw new Error(`${errorPrefix} Missing appKey during init.`);
  }

  if (!site) {
    throw new Error(`${errorPrefix} Missing site during init.`);
  }

  window.ChurnZero = window.ChurnZero || [];

  loadChurnZeroScript(scriptUrl)
    .then(() => {
      const churnZeroData = {
        internalStorage: [],
        contactSet: false,
      };

      const churnZero = {
        // https://support.churnzero.com/hc/en-us/articles/360004683552-Integrate-ChurnZero-using-Javascript for the meaning of these.
        trackEvent: (eventName, description, quantity, custom) => {
          if (eventName) {
            const url = `${window.location.origin}${
              router.resolve(router.currentRoute.fullPath).href
            }`;
            const defaultCustom = { url };

            const item = [
              "trackEvent",
              `${site}-${eventName}`,
              description,
              quantity,
              { ...defaultCustom, ...custom },
            ];

            if (churnZeroData.contactSet) {
              window.ChurnZero.push(item);
            } else {
              churnZeroData.internalStorage.push(item);
            }
          }
        },
        stop: () => {
          window.ChurnZero.push(["stop"]);
          churnZeroData.contactSet = false;
          churnZeroData.internalStorage.length = 0;
        },
        setContact: (accountId, contactId) => {
          if (!churnZeroData.contactSet) {
            // Needed every time we set a new one as stop requires a new one.
            window.ChurnZero.push(["setAppKey", appKey]);
            window.ChurnZero.push(["setContact", accountId, contactId]);
            churnZeroData.contactSet = true;
            while (churnZeroData.internalStorage.length > 0) {
              const item = churnZeroData.internalStorage.pop();
              window.ChurnZero.push(item);
            }
          }
        },
      };

      Vue.prototype.$churnZero = churnZero;
      inject("churnZero", churnZero);

      if (accountId && contactId) {
        churnZero.setContact(accountId, contactId);
      }
    })
    .catch((error) => {
      if (error.target) {
        return console.error(
          `${errorPrefix} Error loading ${error.target.src}. If the file exists you may have an ad- or trackingblocker enabled.`
        );
      }
    });
}
